module.exports = __webpack_public_path__ + "img/179959.e5671c9a.png";